import type { PageLoaderName } from '@/client/confs/page-loaders';

export type RewardsEntryFlags = {
  activityEnrollmentEnabled: boolean;
  activityDistributorAddress: string;
  pointsEnabled: boolean;
  referralEnabled: boolean;
};

export type RewardsEntry = {
  // Where the nav entry navigates.
  href: string;
  // wouter pattern that marks the entry active.
  activePattern: string;
  // Chunk to warm on hover/focus/touch.
  prefetch: PageLoaderName;
  // i18n key (default namespace) for the entry label.
  labelKey: string;
  // invite-earn is a per-uid page, so the entry asks for sign-in first;
  // /rewards renders a signed-out view and should open directly.
  requiresAuth: boolean;
};

// Same condition that registers the /rewards route in routes.tsx: claims
// outlive enrollment (A31), so a configured distributor keeps the page up.
export const isActivityRewardsRouteEnabled = (flags: RewardsEntryFlags) =>
  flags.activityEnrollmentEnabled || Boolean(flags.activityDistributorAddress);

// The nav rewards entry. When the activity page is live it REPLACES the
// invite-earn entry; /user/:uid/invite-earn stays reachable by URL (fee-share
// referral claims live there) but leaves the nav. Null = no entry at all.
export const resolveRewardsEntry = (flags: RewardsEntryFlags, uid: string | undefined): RewardsEntry | null => {
  if (isActivityRewardsRouteEnabled(flags)) {
    return {
      href: '/rewards',
      activePattern: '/rewards',
      prefetch: 'activity-rewards-live',
      labelKey: 'rewards',
      requiresAuth: false,
    };
  }
  if (!flags.pointsEnabled && !flags.referralEnabled) return null;
  return {
    href: `/user/${uid}/invite-earn`,
    activePattern: '/user/:uid/invite-earn',
    prefetch: 'user-invite-earn',
    labelKey: 'routes.user-invite-earn',
    requiresAuth: true,
  };
};
